import styled from 'styled-components';
import { colors } from "colors";

export const Wrapper = styled.div`
  background-color: #f7f7f7;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const InnerWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 1368px;
  z-index: 1;

  a {
    font-size: 14px;
    font-weight: bold;
    color: ${colors.slateGrey};
    text-decoration: none;
  }
`;

export const ToolbarBackground = styled.div`
  position: absolute;
  height: 64px;
  width: 100%;
  background: white;
  border-bottom: 1px solid ${colors.paleGrey};
`;

export const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  height: 64px;
  width: 100%;
  background: white;
  border-bottom: 1px solid ${colors.paleGrey};
  
  span {
    font-size: 14px;
    color: ${colors.slateGrey};
    font-weight: bold;
  }
  
  svg {
    padding: 16px;
    height: 18px;
    width: 18px;
    fill: #fff;
  }
`;

export const ChildrenWrapper = styled.div`
  padding: 24px;
`;

export const MenuBackground = styled.div`
  position: absolute;
  top: 65px;
  height: 48px;
  width: 100%;
  background: white;
`;

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  height: 48px;
  width: 100%;
  background: white;
  
  .active {
    color: ${colors.brightBlue};
  }
  
  .disabled {
    font-size: 14px;
    color: ${colors.charcoalGrey};
    text-decoration: none;
  }
`;


export const StartViewWrapper = styled.div`
  padding: 0 24px;
  display: flex;
  align-items: center;
`;

export const EndViewWrapper = styled.div`
  padding: 0 24px;
  display: flex;
  align-items: center;
`;

export const LoginButtonWrapper = styled.button`
  height: 32px;
  text-align: center;
  border-radius: 24px;
  border: solid 2px #007bff;
  background: transparent;
  color: #007bff;
  padding: 0 32px;
  font-weight: 600;
  flex: 0 0 auto;
  align-self: center;
  cursor: pointer;
  white-space: nowrap;
  align-items: center;
  outline: none;
`;

export const Logo = styled.img`
  height: 32px;
`;

export const ProfileMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
